import React, { useLayoutEffect, useState } from "react";
import styled from "styled-components";
import Header from "./Header";
import Sidebar from "./Sidebar";
import useWindowSize from "../util/hooks/useWindowSize";
import { useRBAC } from "../context/rbac/RBACContext";
import { DashboardModules } from "../config/app.config";

const Layout = styled.div`
	height: 100%;
	width: 100%;
	font-family: "Roboto", sans-serif;
	display: flex;
	flex-direction: column;
`;

const Content = styled.div`
	position: relative;
	width: 100%;
	flex: 1;
	min-width: 0;
	overflow-y: auto;
	height: 100%;
`;

const Div = styled.div`
	position: relative;
	display: flex;
	height: 100%;
	width: 100%;
	overflow-x: hidden;
`;

const AdminLayout = (props) => {
	const [width] = useWindowSize();
	const isMobile = width < 768;
	const [showSidebar, toggle] = useState(false);
	useLayoutEffect(() => {
		toggle(!isMobile);
	}, [isMobile]);
	const { allowedSidebarLinksPerModule } = useRBAC();
	const allowedSidebarLinks = allowedSidebarLinksPerModule[DashboardModules.ADMIN];

	return (
		<Layout>
			<Header title={"Admin"} machinePage={false} showSidebar={showSidebar} toggle={toggle} />
			<Div>
				<Sidebar config={allowedSidebarLinks} showSidebar={showSidebar} toggle={toggle} />
				<Content>{props.children}</Content>
			</Div>
		</Layout>
	);
};

export default AdminLayout;
